export const testTasksStoreKey = 'testTasks';
